import styled from 'styled-components';

import { MAIN_MENU_HEIGHT, SUB_MENU_HEIGHT, CONTACT_MENU } from '../../ui/settings';
import { getSectionGradient, media, space, rems } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';
import fonts from '../../ui/fonts';

const BillboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  height: calc(100vh - ${rems(SUB_MENU_HEIGHT)});

  background-color: ${colors.neutral[1000]};

  ${media.max('medium')`
    height: calc(100vh - ${rems(MAIN_MENU_HEIGHT)}});
  `}

  .topContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;

    padding-top: 7rem;

    ${media.max('medium')`
      flex-direction: column-reverse;

      padding-top: ${rems(MAIN_MENU_HEIGHT)};

      text-align: center;
    `}

    .textWrapper {
      display: flex;
      flex-direction: column;
      gap: 2rem;

      width: 40%;

      span {
        color: ${colors.neutral[100]};
      }

      .title {
        ${fonts.titleLG};
      }

      .claim {
        ${fonts.highlightsMD};
      }

      ${media.max('medium')`
        width: 100%;
      `}

      ${media.max('small')`
        width: 90%;
      `}
    }

    img {
      min-width: 10vw;
      max-width: 35vw;

      ${media.max('medium')`
        max-width: 42vh;
      `}

      ${media.max('small')`
        mad-width: 38vh;
      `}
    }
  }

  .containerCta {
    margin-bottom: 1rem;

    .buttonCta {
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 100%;
    border: 2px solid white;

    width: 2rem;
    height: 2rem;

    .svg {
      width: 0.75rem;
      path {
        fill: ${colors.neutral[100]};
      }
    }
    
    &:hover {
        background-color: ${colors.neutral[200]};
        border: 2px solid ${colors.neutral[200]};
        .svg {
          path {
            fill: ${colors.primary[600]};
          }
        }
      }
    }
  }

  .vertMove {
    animation: mover 1.25s infinite  alternate;
  }

  @keyframes mover {
    0% { transform: translateY(0); }
    100% { transform: translateY(-8px); }
  }
`

export { BillboardContainer };
